import useLabel from "@apps/use-label/use-label";
import { currentOrganizationVar } from "@cache/cache";
import CoreValueIcon from "@components/core-value-icon/core-value-icon";
import { assertEdgesNonNull } from "@helpers/helpers";

import AskAIPlaceholderSuggestedArtifact from "./ask-ai-placeholder-suggested-artifact";

const AskAIPlaceholderSuggestedRecognition = ({
  title,
  coreValueId,
}: {
  title: string;
  coreValueId: number | null;
}) => {
  const organization = currentOrganizationVar();
  const coreValues = assertEdgesNonNull(organization.coreValues);
  const coreValue =
    coreValues.find((coreValue) => coreValue.id === coreValueId) ||
    coreValues[0];
  const label = useLabel();
  return (
    <AskAIPlaceholderSuggestedArtifact
      label={`Give ${label("recognition", { titleCase: true })}`}
      title={title}
      icon={
        <CoreValueIcon
          emoji={coreValue?.emoji}
          image={coreValue?.image}
          imagePxSize={20}
        />
      }
    />
  );
};

export default AskAIPlaceholderSuggestedRecognition;
